import { useDispatch, useSelector } from "react-redux";
import { CloseIcon } from "../../../assets/icons/Svg";
import Input from "../../ui/Input";
import Label from "../../ui/Label";
import { clearSetupType, selectIsShowOption, selectSetupTypeUpdate, selectSetupUpdateId, selectTemperature, setIsShowOption, setTemperature } from "../../../features/setup/setupSlice";
import { useMutationData } from "../../../hooks/api/useMutationData";
import { showToast } from "../../../toastify/Toast";
import { handleApiError } from "../../../utils/handleApiError";
import { CreateNewTemperature, UpdateTemperature } from "../../../features/setup/setupRequestBody";
import DropdownBtn from "../../ui/DropdownBtn";
import { statusList } from "../../../constant/default";

export default function Temperature() {

    const dispatch = useDispatch()
    const temperature = useSelector(selectTemperature)
    const setupTypeUpdate = useSelector(selectSetupTypeUpdate)
    const typeId = useSelector(selectSetupUpdateId)
    const isShow = useSelector(selectIsShowOption)
    const { createTemperature, isLoadingCreateTemperature, updateTemperature, isLoadingUpdateTemperature, } = useMutationData()
    const isUpdateTemperature = setupTypeUpdate === 'setUpTemperatureUpdate'
    const headerTitle = isUpdateTemperature ? 'Update temperature' : 'Add new temperature'
    const isLoading = isLoadingCreateTemperature || isLoadingUpdateTemperature
    const isComplete = !temperature.typeName || (isUpdateTemperature && temperature.isActive === undefined);
    const isDisable = isComplete|| isLoading
    const temperatureStatus =
        temperature.isActive === undefined
        ? "Select status"
            : temperature.isActive
        ? "Active"
            : "Inactive";
    const btnTitle = isLoading ? 
        isUpdateTemperature
            ? "Updating..."
            : "Creating..."
        : isUpdateTemperature
            ? "Save Update"
            : "Save"

    const handleTemperature = async () => {
        try {
            if(!temperature.typeName) return showToast('Temperature name required.','error')
            
            if(isUpdateTemperature) {
                if(!typeId) return showToast('Missing temperature id', 'error')
                if(temperature.isActive === undefined) return showToast("Temperature status required.", "error");
                
                const body: UpdateTemperature = {
                    typeName: temperature.typeName,
                    isActive: temperature.isActive 
                }
                await updateTemperature({ temperatureId: typeId, body}).unwrap()
                showToast('Temperature updated successfully', 'success')
            } else {
                const body: CreateNewTemperature = {
                    typeName: temperature.typeName
                }
                await createTemperature(body).unwrap()
                showToast('Temperature created successfully', 'success')
            }
            dispatch(clearSetupType({ temperature: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))
        } catch (error) {
            handleApiError(error)
        }
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                                    {headerTitle}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={() => dispatch(clearSetupType({ temperature: true, setupTypeId: true, setupType: true, setupTypeUpdate: true }))}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Temperature name*'}/>
                                    <Input
                                        type={'text'}
                                        value={temperature.typeName}
                                        onChange={(e) => dispatch(setTemperature({ typeName: e.target.value }))}
                                        required
                                        disabled={isLoading}
                                    />
                                </div>
                                {isUpdateTemperature && (
                                    <div className=''>
                                        <Label label={'Status *'}/>
                                        <div className='relative inline-block h-auto w-full'>
                                            <div className='w-full h-auto'>
                                                <DropdownBtn
                                                    label={temperatureStatus}
                                                    isOpen={isShow}
                                                    onClick={() => dispatch(setIsShowOption(!isShow))}
                                                    isCustomClass={true}
                                                    disabled={isLoading}
                                                    customClass={'flex w-full justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                                                />
                                                {isShow && (
                                                <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                                    {statusList.map((stat) => (
                                                        <li
                                                            key={stat.statusId}
                                                            onClick={() => {
                                                                dispatch( setTemperature({ isActive: stat.isActive, }) );
                                                                dispatch(setIsShowOption(false));
                                                            }}
                                                            className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                                                        >
                                                            {stat.status}
                                                        </li>
                                                    ))}
                                                </ul>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <button 
                            onClick={handleTemperature}
                            disabled={isDisable}
                            className={`w-full text-xs px-2 py-2 rounded font-medium transition-all shadow-md bg-cbColor
                                ${isComplete ? 'cursor-not-allowed bg-gray-200 border text-black' :  !isLoading ? 'text-white' : 'text-white'}
                            `}
                        >
                            {btnTitle}
                        </button> 
                    </div>
                </div>
            </div>
        </div>
    )
}
